import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import styles from './Translations.scss'
import { Key } from '../shared/Key'
import { ValuesForSet } from '../shared/ValuesForSet'
import { CircleSpinner } from 'common/spinners'
import { CTA } from 'common/styleguide/CTA'
import { Card } from 'common/styleguide/Card'
import { tmsKeyActions, tmsKeySelectors } from 'data/resources/tmsKeys'

export const _Translations = ({
  tmsSetId,
  keysForSet,
  loadKeys,
  verifyKey,
  keypaneId,
  expanded,
  toggleExpanded
}) => {
  const [loadingKeys, setLoadingKeys] = useState(false)

  useEffect(() => {
    if (tmsSetId) {
      setLoadingKeys(true)
      console.log('translations load')
      Promise.all([loadKeys()]).finally(() => {
        setLoadingKeys(false)
      })
    }
  }, [tmsSetId])

  if (!tmsSetId) {
    return <p>&larr; pick one</p>
  }

  if (loadingKeys) {
    return <CircleSpinner centered size={40} />
  }

  return <Card noPadding className={styles.translationCard}>
    <SetPane
      keysForSet={keysForSet} />
    <ValuesForSet tmsSetId={tmsSetId} />
  </Card>
}

const SetPane = ({
  keysForSet
}) => {
  return <div className={styles.KeyPane}>
    {keysForSet.valueSeq().map(tmsKey => {
      return <div key={tmsKey.id} className={styles.topPane}>
        <div className={styles.left}>
          <Key tmsKey={tmsKey} />
        </div>
        <CTA secondary margins={false} to={`/tms/jobs/${tmsKey.tmsJobId}`} style={{ margin: '0px auto' }}>go to job (#{tmsKey.tmsJobId})</CTA>
      </div>
    })}
  </div>
}

const mapStateToProps = (state, ownProps) => {
  const tmsSetId = ownProps.tmsSetId ?? parseInt(ownProps.params?.id, 10)
  return {
    tmsSetId,
    keysForSet: tmsKeySelectors.byTmsSetId(state, tmsSetId)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const tmsSetId = ownProps.tmsSetId ?? parseInt(ownProps.params?.id, 10)
  return {
    loadKeys: () => dispatch(tmsKeyActions.list({ tmsSetId }))
  }
}

export const Translations = connect(
  mapStateToProps,
  mapDispatchToProps
)(_Translations)
